export interface SkillPillProps {
  text: string;
  accent: string;
}

export default function SkillPill({ text, accent }: SkillPillProps) {
  return (
    <li
      className="inline-flex items-center rounded-full border px-3 py-0.5 text-[12.5px] font-medium max-w-full text-black"
      style={{ borderColor: accent }}
    >
      <span>{text}</span>
    </li>
  );
}
